import _ from 'lodash';

const moduleName = 'ProspectingProjectUser';
const modulePath = _.kebabCase(moduleName);

export default {
  moduleName,
  modulePath,
};
